import api from '../api';

// MIGRATION: Independent agents now use the unified /clients endpoints.
// The backend filters by agent_id automatically based on the authenticated
// user's role, so the request/response shape is identical to what this
// facade previously returned from /independent/clients.
export const independentClientsService = {
  getAll: async () => {
    const response = await api.get('/clients');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/clients/${id}`);
    return response.data;
  },

  create: async (clientData) => {
    const response = await api.post('/clients', clientData);
    return response.data;
  },

  update: async (id, clientData) => {
    const response = await api.put(`/clients/${id}`, clientData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/clients/${id}`);
    return response.data;
  },

  getClientQuotes: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/quotes`);
    return response.data;
  },

  getClientItineraries: async (clientId) => {
    const response = await api.get(`/clients/${clientId}/itineraries`);
    return response.data;
  }
};

export default independentClientsService;
